import { WelcomeVideo } from './WelcomeVideo';
export default WelcomeVideo;
